import { OneColumn } from 'components/page';
import { RevendedorGrid, RevendedorGridFilter, RevendedorReport } from 'pages/revendedor/revendedor/components';

export function RevendedorListComp() {
    return (
        <OneColumn title="Revendedores" createButton>
            <RevendedorGridFilter />

            <RevendedorReport />

            <RevendedorGrid />
        </OneColumn>
    );
}
